import Spinner from './Spinner';

/* The "still fetching" line used inside cards — spinner + what's loading. */
export default function LoadingRow({ children }) {
  return (
    <div className="hint" style={{ display: 'flex', alignItems: 'center', gap: 6, padding: '8px 0' }}>
      <Spinner variant="green" /> {children}
    </div>
  );
}
